import { SidebarSection, FeatureCard, FileTab } from '../types';

export const SIDEBAR_NAV: SidebarSection[] = [
  {
    section: 'MAIN',
    items: [
      { icon: '⬡', label: 'Dashboard',    path: '/dashboard' },
      { icon: '⧉', label: 'Stock Avg',    path: '/stock-avg' },
      { icon: '⌨', label: 'Price Calc',    path: '/profit-calc' },
      { icon: '⌨', label: 'Code Editor',  path: '/editor',       badge: 'JS' },
      { icon: '⬢', label: 'APK Builder',  path: '/apk' },
      { icon: '◎', label: 'Architecture', path: '/architecture' },
    ],
  },
  {
    section: 'TOOLS',
    items: [
      { icon: '◈', label: 'Converter', path: '/converter' },
      { icon: '⧉', label: 'Assets',    path: '/assets' },
    ],
  },
  {
    section: 'SETTINGS',
    items: [
      { icon: '◌', label: 'Deploy', path: '/deploy' },
    ],
  },
];

export const NAV_LINKS = ['Dashboard', 'Docs', 'Templates', 'Community'];

export const FEATURE_CARDS: FeatureCard[] = [
  {
    icon: '⧉',
    title: 'Stock Avg',
    description: 'Full-featured editor with syntax highlighting, tab management, and live code stats.',
    actionLabel: 'Open $tock Avg',
    path: '/stock-avg',
  },
  {
    icon: '⌨',
    title: 'Code Editor',
    description: 'Full-featured editor with syntax highlighting, tab management, and live code stats.',
    actionLabel: 'Open Editor',
    path: '/editor',
  },
  {
    icon: '⬢',
    title: 'APK Builder',
    description: 'Compile your React Native project to a signed, release-ready APK with one click.',
    actionLabel: 'Build Now',
    path: '/apk',
  },
  {
    icon: '◎',
    title: 'Architecture',
    description: 'Explore project structure, component hierarchy, and dependency graph.',
    actionLabel: 'View Arch',
    path: '/architecture',
  },
  {
    icon: '◈',
    title: 'APK Converter',
    description: 'Convert existing React apps to Android APK using Capacitor or React Native WebView.',
    actionLabel: 'Convert',
    path: '/converter',
  },
  {
    icon: '⧉',
    title: 'Asset Manager',
    description: 'Manage icons, splash screens, and app resources for multiple screen densities.',
    actionLabel: 'Browse Assets',
    path: '/assets',
  },
  {
    icon: '◎',
    title: 'Deploy',
    description: 'Push directly to Google Play Store or generate an install link for side-loading.',
    actionLabel: 'Deploy',
    path: '/deploy',
  },
];

export const EDITOR_TABS: FileTab[] = [
  { id: 'app',      label: 'App.tsx',             language: 'TypeScript' },
  { id: 'manifest', label: 'app.config.json',      language: 'JSON' },
  { id: 'arch',     label: 'architecture.md',      language: 'Markdown' },
  { id: 'styles',   label: 'theme/variables.css',  language: 'CSS' },
];

export const BUILD_PHASES = [
  'Bundling JS',
  'Compiling Resources',
  'Assembling APK',
  'Signing',
  'Optimizing',
];

export const FOOTER_LINKS = {
  Product: ['Code Editor', 'APK Builder', 'Converter', 'Templates', 'Changelog'],
  Docs:    ['Getting Started', 'React Native', 'Gradle Config', 'Signing Guide', 'Troubleshoot'],
  Community: ['GitHub', 'Discord', 'Forum', 'Roadmap', 'Blog'],
};
